import { disableScrollForInputDrawer, enableScrollForInputDrawer } from '~/js/utils/dom';

const openDrawers = new Set();

const drawer = (name) => ({
  isClosing: false,
  // Note: it's important to set up props here first b/c not doing and using
  // ...`this.mutationObserver = ...` for example would set mutationObserver for the parent component
  // ... and not necessarily this drawer component
  openDrawer: null,
  closeDrawer: null,
  animationEndHandler: null,
  mutationObserver: null,

  init() {
    // bind 'this' so that openDrawers.delete works since it needs to reference 'this' in any instance of drawer-v2
    this.openDrawer = this._openDrawer.bind(this);
    this.closeDrawer = this._closeDrawer.bind(this);
    this.animationEndHandler = this._animationEndHandler.bind(this);

    this.mutationObserver = new MutationObserver(this.handleMutation.bind(this));
    this.mutationObserver.observe(this.$el, {
      attributes: true,
      attributeFilter: ['open'],
    });
  },

  async _openDrawer() {
    this.$dispatch('drawer-open', { drawer: this });
    this.$el.showModal();
  },

  _animationEndHandler() {
    openDrawers.delete(this);
    this.$dispatch('drawer-close', { drawer: this });
    this.$el.close();
    this.isClosing = false;

    this.$el.removeEventListener('transitionend', this.animationEndHandler);
  },

  _closeDrawer() {
    this.$el.addEventListener('transitionend', this.animationEndHandler);
    this.$nextTick(() => {
      this.isClosing = true;
    });
  },

  handleOpenDrawer(evt) {
    if (evt.detail.drawerName === name) {
      this._openDrawer();
    }
  },

  handleCloseDrawer(evt) {
    if (evt.detail.drawerName === name) {
      this._closeDrawer();
    }
  },

  destroy() {
    openDrawers.delete(this);
  },

  closeOpenDrawers() {
    openDrawers.forEach((drawer) => {
      drawer.closeDrawer();
    });
  },

  handleMutation() {
    if (this.isClosing) return;

    const { open: newOpen } = this.$el;

    if (newOpen) {
      openDrawers.add(this);
      document.body.classList.add('scroll-lock');
      window.isMobile && disableScrollForInputDrawer();
    } else {
      openDrawers.delete(this);
      if (openDrawers.size === 0) {
        document.body.classList.remove('scroll-lock');
        window.isMobile && enableScrollForInputDrawer();
      }
    }

    this.$dispatch(newOpen ? 'drawer-open' : 'drawer-close', {
      drawer: this,
    });
  },
});

export default drawer;
